import React from 'react'

import { Switch, Typography } from 'antd'

import EmptyData from '../../../../../../assets/images/emptyCustomFields.svg'
import CustomInput from '../../../../../../components/CustomInput/customInput'
import CustomSelect from '../../../../../../components/CustomSelect/customSelect'
import { getMessage } from '../../../../../../util/IntlMessages'
import { SelectOptionsProvider } from '../../context/selectOptions'
import { useManageField } from '../../hooks/useManageFields'
import { AutomaticFilling } from '../AutomaticFilling'
import { GroupsAndFieldsOrder } from '../GroupsAndFieldsOrder'
import { SelectOptions } from '../SelectOptions'
import { ViewParams } from '../ViewParams'
import { DATE_FORMAT, FILE_OPTIONS, FILE_SIZE_TYPE } from './data'

import './styles.less'

export function FieldProperties() {
  const { updateField, currentField, selectedFieldId, fields } = useManageField()

  const setFieldProperties = ({ property, value, fieldId }) => {
    updateField({
      fieldId,
      property: 'fieldProperties',
      value: { ...currentField.fieldProperties, [property]: value }
    })
  }

  const setField = ({ property, value, fieldId }) => {
    updateField({ property, value, fieldId })
  }

  return !currentField ? (
    <div className="fieldProperties--empty">
      <img className="empty-fields-image" src={EmptyData} alt="empty_data" />
      <Typography>{getMessage('clickToSelectField')}</Typography>
      <Typography>{getMessage('clickToEditField')}</Typography>
    </div>
  ) : (
    <div className="fieldProperties">
      <div className="fieldProperties__content">
        {'requiredField' in currentField && (
          <div className="fieldProperties__requiredField">
            <Typography>{getMessage('isFieldRequired')}</Typography>
            <Switch
              checked={currentField.requiredField}
              onChange={(value) => setField({ property: 'requiredField', value, fieldId: selectedFieldId })}
            />
          </div>
        )}

        <div className="fieldProperties__input">
          <CustomInput
            field="fieldName"
            setFieldValue={(property, value) => setField({ property, value, fieldId: selectedFieldId })}
            setField={setField}
            value={currentField}
          />
        </div>

        {currentField.internalTypeName === 'group' && (
          <div className="fieldProperties__input">
            <CustomInput
              field="groupType"
              setFieldValue={(property, value) => setField({ property, value, fieldId: selectedFieldId })}
              setField={setField}
              value={currentField}
            />
          </div>
        )}

        {'placeholder' in currentField.fieldProperties && (
          <div className="fieldProperties__input">
            <CustomInput
              field="placeholder"
              setFieldValue={(property, value) =>
                setFieldProperties({
                  property,
                  value,
                  fieldId: selectedFieldId
                })
              }
              value={currentField.fieldProperties}
            />
          </div>
        )}

        {'minValue' in currentField.fieldProperties && (
          <div className="fieldProperties__input">
            <CustomInput
              field="minValue"
              type="number"
              setFieldValue={(property, value) =>
                setFieldProperties({
                  property,
                  value,
                  fieldId: selectedFieldId
                })
              }
              value={currentField.fieldProperties}
            />
          </div>
        )}

        {'maxValue' in currentField.fieldProperties && (
          <div className="fieldProperties__input">
            <CustomInput
              field="maxValue"
              type="number"
              setFieldValue={(property, value) =>
                setFieldProperties({
                  property,
                  value,
                  fieldId: selectedFieldId
                })
              }
              value={currentField.fieldProperties}
            />
          </div>
        )}

        {'maxLength' in currentField.fieldProperties && (
          <div className="fieldProperties__input">
            <CustomInput
              field="maxLength"
              type="number"
              setFieldValue={(property, value) =>
                setFieldProperties({
                  property,
                  value,
                  fieldId: selectedFieldId
                })
              }
              value={currentField.fieldProperties}
            />
          </div>
        )}

        {currentField.internalTypeName === 'select' && (
          <SelectOptionsProvider>
            <SelectOptions />
          </SelectOptionsProvider>
        )}

        {'fileType' in currentField.fieldProperties && (
          <div className="fieldProperties__input">
            <CustomSelect
              field="fileType"
              setFieldValue={(property, value) =>
                setFieldProperties({
                  property,
                  value,
                  fieldId: selectedFieldId
                })
              }
              value={currentField.fieldProperties}
              values={FILE_OPTIONS}
              multiple
            />
          </div>
        )}

        {'fileSize' in currentField.fieldProperties && (
          <div className="fieldProperties__input">
            <CustomInput
              field="fileSize"
              type="number"
              setFieldValue={(property, value) =>
                setFieldProperties({
                  property,
                  value,
                  fieldId: selectedFieldId
                })
              }
              value={currentField.fieldProperties}
            />
          </div>
        )}

        {'sizeType' in currentField.fieldProperties && (
          <div className="fieldProperties__input">
            <CustomSelect
              field="sizeType"
              type="number"
              setFieldValue={(property, value) =>
                setFieldProperties({
                  property,
                  value,
                  fieldId: selectedFieldId
                })
              }
              value={currentField.fieldProperties}
              values={FILE_SIZE_TYPE}
            />
          </div>
        )}

        {'maxFilesLength' in currentField.fieldProperties && (
          <div className="fieldProperties__input">
            <CustomInput
              field="maxFilesLength"
              type="number"
              setFieldValue={(property, value) =>
                setFieldProperties({
                  property,
                  value,
                  fieldId: selectedFieldId
                })
              }
              value={currentField.fieldProperties}
            />
          </div>
        )}

        {'format' in currentField.fieldProperties && (
          <div className="fieldProperties__input">
            <CustomSelect
              field="format"
              setFieldValue={(property, value) =>
                setFieldProperties({
                  property,
                  value,
                  fieldId: selectedFieldId
                })
              }
              value={currentField.fieldProperties}
              values={DATE_FORMAT}
            />
          </div>
        )}

        {currentField.internalTypeName !== 'group' && <GroupsAndFieldsOrder />}

        {currentField.internalTypeName !== 'group' && (
          <ViewParams
            allCustomFields={Object.values(fields.entities)}
            customField={currentField}
            setField={setField}
            selectedFieldId={selectedFieldId}
          />
        )}

        {currentField.internalTypeName !== 'group' && (
          <AutomaticFilling
            fieldProperties={currentField.fieldProperties}
            setFieldProperties={setFieldProperties}
            selectedFieldId={selectedFieldId}
          />
        )}
      </div>
    </div>
  )
}
